import {
  Tabs,
  TabList,
  Tab,
  Flex,
  Tag,
  TabPanels,
  TabPanel,
  Box,
  Text,
} from '@chakra-ui/react';
import { sampleLifecycleGroupTitle } from '@texas/components/shared/samples/translations';
import {
  SampleLifecycleGroup,
  sampleLifecycleGroupConfig,
} from '@texas/components/shared/samples/types';
import { BlueDot } from '@texas/components/shared/tracker/BlueDot';
import { fadeInAnimation } from '@texas/resources/animations/animations';
import { convertToEnum } from '@texas/utils/helpers/enumHelpers';
import { useTranslation } from 'react-i18next';
import { SamplesTable } from './SamplesTable';
import { SamplesWidgetContext } from './SamplesWidget';
import { useActiveContext } from '@texas/hooks/useActiveContext';
import { TagFilterProvider } from '@texas/components/shared/tags/TagFilterContext';

export function TableView() {
  const { t } = useTranslation();

  const samplesContext = useActiveContext(SamplesWidgetContext);

  return (
    <TagFilterProvider>
      <Tabs isLazy={true}>
        <TabList>
          {samplesContext.groupConfigs.map((s) => {
            const groupEnum = convertToEnum(SampleLifecycleGroup, s);

            const config =
              sampleLifecycleGroupConfig[
                s as keyof typeof SampleLifecycleGroup
              ];
            const am = samplesContext.sampleGroups[groupEnum].length;

            const hasAnyChangeSinceLastTrack = samplesContext.sampleGroups[
              groupEnum
            ].some((sample) => sample.isChangedSinceLastTrack);

            return (
              <Tab key={s}>
                <BlueDot show={hasAnyChangeSinceLastTrack}>
                  <Flex gap={1} align="center">
                    <Tag>{am}</Tag>
                    {config.icon}
                    <Text>{sampleLifecycleGroupTitle(groupEnum, t)}</Text>
                  </Flex>
                </BlueDot>
              </Tab>
            );
          })}
        </TabList>
        <TabPanels>
          {samplesContext.groupConfigs.map((s) => {
            const groupEnum = convertToEnum(SampleLifecycleGroup, s);

            return (
              <TabPanel key={s}>
                <Box animation={fadeInAnimation()} key={s}>
                  <SamplesTable groupEnum={groupEnum} />
                </Box>
              </TabPanel>
            );
          })}
        </TabPanels>
      </Tabs>
    </TagFilterProvider>
  );
}
